import { render, staticRenderFns } from "./upload_dropzone.vue?vue&type=template&id=0589500e&vue3"
import script from "./upload_dropzone.vue?vue&type=script&lang=js&vue3"
export * from "./upload_dropzone.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports